'use strict';

interface TyreAwardsList {
  tyreAwardsContainer: HTMLElement | null;
  awardsContainer: HTMLElement | null;
  awardItems: HTMLElement[];
  filterSelects: NodeListOf<HTMLSelectElement> | null;
  filterAwardsBy(filter: string, value: string): void;
  init(element: HTMLElement): void;
}

let tyreAwards: TyreAwardsList = {
  tyreAwardsContainer: null,
  awardsContainer: null,
  awardItems: [],
  filterSelects: null,

  filterAwardsBy(filter, value){

     if(filter === 'tyre-group-filter'){
      for (const item of this.awardItems) {
        let groupFilterGroupSlugs = item.dataset.tyreGroupFilterSlugs;
        let groupFilterGroups = (typeof groupFilterGroupSlugs === 'string' ? groupFilterGroupSlugs.split(',') : []);

        if(!value || value === '' || groupFilterGroups.indexOf(value) > -1){
          item.style.display = 'grid';
        } else {
          item.style.display = 'none';
        }
      };
      return;
    }
    if(filter === 'tyre'){
      for (const item of this.awardItems) {
        let tyreSlug = item.dataset.tyreSlug;

        if(!value || value === '' || tyreSlug === value){
          item.style.display = 'grid';
        } else {
          item.style.display = 'none';
        }
      };
      return;
    }
    if(filter === 'test-season'){
      for (const item of this.awardItems) {
        let testSeason = item.dataset.testSeasonSlug;

        if(!value || value === '' || testSeason === value){
          item.style.display = 'grid';
        } else {
          item.style.display = 'none';
        }
      };
      return;
    }
  },

  init: function(element: HTMLElement){

    this.tyreAwardsContainer = element;

    console.log('tyreAwardsList.init()');

    let self = this;

    this.awardsContainer = this.tyreAwardsContainer.querySelector('[data-awards]');
    if (!this.awardsContainer) return;

    this.awardItems = Array.from(this.awardsContainer.querySelectorAll('[data-award]'));
    this.filterSelects = this.tyreAwardsContainer.querySelectorAll('select[data-awards-filter]');

    this.filterSelects.forEach(select => {

      select.addEventListener('change', function(e){
        let filterSelect = e.target as HTMLSelectElement;
        let filter = select.dataset.awardsFilter || '';
        let value = filterSelect.value;

        self.filterSelects?.forEach(select => {
          if(select !== filterSelect){
            select.value = '';
          }
        });

        self.filterAwardsBy(filter, value);
    });

  });
}

};

export default tyreAwards;
